import React, { Component } from 'react';
import moment from 'moment';
import { FORMAT_NUMBER, CURRENCY } from '../libs/utils/Const';
import './Dropup.css'
import $ from "jquery";
import { ToolTip } from "./index";

class EntryTransfers extends Component {
    DoSearch = async (data, searchTerm) => {
        const tableReg = document.getElementById(data);
        const searchText = document.getElementById(searchTerm).value.toLowerCase();
        let total = 0;
        // Recorremos todas las filas con contenido de la tabla
        for (let i = 1; i < tableReg.rows.length; i++) {
            // Si el td tiene la clase "noSearch" no se busca en su contenido
            // if (tableReg.rows[i].classList.contains("noSearch")) {
            //     continue;
            // }
            let found = false;
            const cellsOfRow = tableReg.rows[i].getElementsByTagName('td');
            // Recorremos todas las celdas
            for (let j = 0; j < cellsOfRow.length && !found; j++) {
                const compareWith = cellsOfRow[j].innerHTML.toLowerCase();
                // Buscamos el texto en el contenido de la celda
                if (searchText.length == 0 || compareWith.indexOf(searchText) > -1) {
                    found = true;
                    total++;
                }
            }
            if (found) {
                tableReg.rows[i].style.display = '';
            } else {
                // si no ha encontrado ninguna coincidencia, esconde la
                // fila de la tabla
                tableReg.rows[i].style.display = 'none';
            }
        }
    }

    render() {
        const { data, GetMyStockTransfers, CloseActions } = this.props
        return (
            <>
                <div className="modal fade" id="entryTransfers" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="entryTransfersModal" aria-hidden="true" >
                    <div className="modal-dialog modal-xl modal-dialog" >
                        <div className="modal-content">
                            <div className="modal-header text-white" style={{ background: "#343a40" }}>

                                <div className='col-9'>
                                    <h4 className="modal-title" id="modal-basic-title ">
                                        TRANSPASOS PENDIENTES
                                    </h4>
                                </div>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{ color: "white" }} onClick={() => { CloseActions() }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="mt-2">
                                    <section>
                                        <ul className="nav nav-tabs" id="myTabTransfers" role="tablist">

                                            <li className="nav-item waves-effect waves-light">
                                                <h5 className="nav-link active" id="general-tab" data-toggle="tab" href="#general" role="tab" aria-controls="general-tab" aria-selected="false" onClick={() => GetMyStockTransfers(1)}>CEDIS</h5>
                                            </li>

                                            <li className="nav-item waves-effect waves-light">

                                                <h5 className="nav-link" id="Transit-tab" data-toggle="tab" href="#transit" role="transit-tab" aria-controls="transit-tab" aria-selected="false" onClick={() => GetMyStockTransfers(2)}>
                                                    <div className='row'>

                                                        <ToolTip tips={[{ message: 'Estos documentos los encontraran los respectivos autorizadores en el modulo "Documentos por autorizar"' }]} position={'up'} />
                                                        <label className='ml-2'>Transito</label>
                                                    </div>


                                                </h5>
                                            </li>

                                        </ul>
                                        <div className="tab-content" id="myTabContent" style={{ border: "1px solid #dee2e6", borderTop: "none" }}>

                                            {/* ------------------------------------- CEDIS --------------------------------------------------------- */}
                                            <div className="tab-pane fade active show" id="general" role="tabpanel" aria-labelledby="general-tab">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className='scrollTableSaves' style={{ maxHeight: "630px", minHeight: "120px" }}>
                                                            <table className="table table-striped table-hover" id="CEDIS">
                                                                <thead>
                                                                    <tr>
                                                                        <th className="text-center" colSpan={2}>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control "
                                                                                placeholder="Buscar en CEDIS"
                                                                                id="CEDISSearch"
                                                                                onKeyUp={() => this.DoSearch("CEDIS", "CEDISSearch")}
                                                                            />
                                                                        </th>
                                                                        <th className="text-center">Fecha</th>
                                                                        {/* <th className="text-center">Hora</th> */}
                                                                        <th className="text-center">Dias atraso</th>
                                                                        <th className="text-center">Monto</th>
                                                                        {/* <th className="text-center"></th> */}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {this.props.hasOwnProperty("data") && data.map((doc, index) => {
                                                                        return (
                                                                            <tr key={index + 'entryCedis'}>
                                                                                {/* <td className="text-center">
                                                                                    <input type='radio'
                                                                                        className='cursor-pointer ml-3'
                                                                                    // checked={SavedSalesTools.chooseSavedSale === doc.folio ? true : false}
                                                                                    // onChange={() => SavedSalesTools.OnchangeChooseSale(doc.folio, false)}
                                                                                    >
                                                                                    </input>
                                                                                </td> */}
                                                                                <td className="text-center">No. Doc:</td>
                                                                                <td className="text-center">{doc?.DocNum ?? ''}</td>
                                                                                <td className="text-center">{doc.TaxDate ? moment(doc.TaxDate).utc().format('YYYY-MM-DD') : ''}</td>
                                                                                {/* <td className="text-center">{doc?.DocTime !== null ? (doc?.DocTime ?? '').toString().length > 4 ? doc?.DocTime : moment(doc?.DocTime).format('LT') : ''}</td> */}
                                                                                <td className="text-center">{doc.daysLast ?? 0}</td>
                                                                                <td className="text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new(doc.DocTotal)}</td>
                                                                                {/* <td className="text-center" style={{ color: "#dc3545" }} onClick={() => { }}>
                                                                                    <i className="fa fa-trash-o cursor-pointer mr-3" />
                                                                                </td> */}
                                                                            </tr>
                                                                        );
                                                                    })
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                            {/* ------------------------------------- TRANSITO --------------------------------------------------------- */}
                                            <div className="tab-pane fade show" id="transit" role="transit-tab" aria-labelledby="transit-tab">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className='scrollTableSaves' style={{ maxHeight: "630px", minHeight: "120px" }}>
                                                            <table className="table table-striped table-hover" id="transit">
                                                                <thead>
                                                                    <tr>
                                                                        <th className="text-center" colSpan={2}>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control "
                                                                                placeholder="Buscar en Transito"
                                                                                id="transitSearch"
                                                                                onKeyUp={() => this.DoSearch("transit", "transitSearch")}
                                                                            />
                                                                        </th>
                                                                        <th className="text-center">Fecha</th>
                                                                        <th className="text-center">Autorización</th>
                                                                        <th className="text-center">Dias atraso</th>
                                                                        <th className="text-center">Monto</th>
                                                                        {/* <th className="text-center"></th> */}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {this.props.hasOwnProperty("data") && data.map((doc, index) => {
                                                                        return (
                                                                            <tr key={index + 'entryTransit'}>
                                                                                {/* <td className="text-center">
                                                                                    <input type='radio'
                                                                                        className='cursor-pointer ml-3'
                                                                                    // checked={SavedSalesTools.chooseSavedSale === doc.folio ? true : false}
                                                                                    // onChange={() => SavedSalesTools.OnchangeChooseSale(doc.folio, false)}
                                                                                    >
                                                                                    </input>
                                                                                </td> */}
                                                                                <td className="text-center">{`${doc?.Filler ?? ''}->`}</td>
                                                                                <td className="text-center">{doc?.U_FMB_Or_Destination ?? ''}</td>
                                                                                <td className="text-center">{doc.TaxDate ? moment(doc.TaxDate).utc().format('YYYY-MM-DD') : ''}</td>
                                                                                <td className="text-center">{doc?.Name ?? ''}</td>
                                                                                <td className="text-center">{doc.daysLast ?? 0}</td>
                                                                                <td className="text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new(doc.DocTotal)}</td>
                                                                                {/* <td className="text-center" style={{ color: "#dc3545" }} onClick={() => { }}>
                                                                                    <i className="fa fa-trash-o cursor-pointer mr-3" />
                                                                                </td> */}
                                                                            </tr>
                                                                        );
                                                                    })
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>


                                        </div>

                                    </section>
                                </div>
                            </div>
                            <div className="modal-footer">
                                {/* <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => { }}>Cerrar</button> */}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default EntryTransfers;